var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276.69,
    height: 266,
    viewBox: "0 0 276.69 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.69,0H0V266H276.69Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23,44.8h13V57.7l-7.6-7.6Z",
    transform: "translate(0 -2.07)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,92.1a22.29,22.29,0,1,1-18.7-34.4,22.24,22.24,0,0,1,18.7,10",
    transform: "translate(0 -2.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,92.1a22.29,22.29,0,1,1-18.7-34.4,22.24,22.24,0,0,1,18.7,10",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,71c-1.6-1.3-3.8-1.8-6.5-1.8h-8.5v16h-3.1v2.9h3.1v2.4h3.1V88.1H49v-3h-6.6V83.3h5.4a10.27,10.27,0,0,0,6.5-1.8,6.38,6.38,0,0,0,2.4-5.3A6.06,6.06,0,0,0,54.33,71Zm-2.2,8.7a6.79,6.79,0,0,1-4.4,1.3h-5.4V71.9h5.5a7.94,7.94,0,0,1,4.4,1.1,4,4,0,0,1,1.6,3.4A5.85,5.85,0,0,1,52.13,79.7Z",
    transform: "translate(0 -2.07)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.43,98.7a18.9,18.9,0,1,0-19-18.9A18.91,18.91,0,0,0,45.43,98.7Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.43,262.1H80.73a16.69,16.69,0,0,1-16.8-16.7V20.6A16.75,16.75,0,0,1,80.73,3.9h113.7a16.69,16.69,0,0,1,16.8,16.7V245.4A16.82,16.82,0,0,1,194.43,262.1Z",
    transform: "translate(0 -2.07)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,251.7a6.43,6.43,0,0,1-6.4-6.3V20.6a6.43,6.43,0,0,1,6.4-6.3h113.7a6.43,6.43,0,0,1,6.4,6.3V245.4a6.43,6.43,0,0,1-6.4,6.3Z",
    transform: "translate(0 -2.07)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,246.7a1.26,1.26,0,0,1-1.3-1.3V20.6a1.26,1.26,0,0,1,1.3-1.3h113.7a1.26,1.26,0,0,1,1.3,1.3V245.4a1.26,1.26,0,0,1-1.3,1.3Z",
    transform: "translate(0 -2.07)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,38.3h147.2",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,226.2h147.2",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,239.6H152",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.21,
    y: 152.47,
    width: 10.7,
    height: 40.4,
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.93,
    y: 168.33,
    width: 10.8,
    height: 23.9,
    fill: "#fffdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,132a9.4,9.4,0,1,0-9.5-9.4A9.47,9.47,0,0,0,127,132Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,126.7a4.2,4.2,0,1,0-4.2-4.2A4.16,4.16,0,0,0,127,126.7Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,162.2a9.4,9.4,0,1,0-9.5-9.4A9.47,9.47,0,0,0,149.43,162.2Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,157a4.2,4.2,0,1,0-4.2-4.2A4.23,4.23,0,0,0,149.43,157Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.13,118.4l-43.2,42.8",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.13,138.5c0,4.2-4.9,7.8-6,11.6-1.1,4,1.5,9.6-.5,13-2,3.6-8.2,4.2-11.1,7.1s-3.5,8.9-7.1,11.1c-3.5,2-9.1-.5-13.1.5-3.8,1.1-7.5,6-11.7,6s-7.8-4.9-11.7-6-9.7,1.5-13.1-.5c-3.6-2-4.2-8.2-7.1-11.1s-8.9-3.4-11.1-7.1c-2-3.4.5-9.1-.5-13s-6-7.4-6-11.6,4.9-7.8,6-11.6c1.1-4-1.5-9.6.5-13,2-3.6,8.2-4.2,11.1-7.1s3.5-8.9,7.1-11.1c3.5-2,9.1.5,13.1-.5,3.8-1.1,7.5-6,11.7-6s7.8,4.9,11.7,6,9.7-1.4,13.1.5c3.6,2,4.2,8.2,7.1,11.1s8.9,3.4,11.1,7.1c2,3.4-.5,9.1.5,13S187.13,134.3,187.13,138.5Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.63,182.7c-3.8,0-6.9-4.9-10.4-5.8s-8.7,1.6-11.8-.2c-3.3-1.8-3.5-7.6-6-10.1s-8.4-2.7-10.2-6c-1.8-3.1.9-8.2-.2-11.8-.9-3.4-5.8-6.5-5.8-10.3s4.9-6.9,5.8-10.3c.9-3.6-1.6-8.7.2-11.8,1.8-3.3,7.7-3.4,10.2-6s2.7-8.3,6-10.1c3.1-1.8,8.2.9,11.8-.2,3.5-.9,6.6-5.8,10.4-5.8s6.9,4.9,10.4,5.8,8.7-1.6,11.8.2c3.3,1.8,3.5,7.6,6,10.1s8.4,2.7,10.2,6c1.8,3.1-.9,8.2.2,11.8.9,3.4,5.8,6.5,5.8,10.3s-4.9,6.9-5.8,10.3c-.9,3.6,1.6,8.7-.2,11.8-1.8,3.3-7.6,3.4-10.2,6s-2.7,8.3-6,10.1c-3.1,1.8-8.2-.9-11.8.2C144.53,177.8,141.43,182.7,137.63,182.7Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.23,124.1a44,44,0,0,0,17.3-1.1,2,2,0,0,0,1-1,1.55,1.55,0,0,0-.4-1.4,1.69,1.69,0,0,0-1.4-.4,42.56,42.56,0,0,1-16.3,1A41.31,41.31,0,0,1,3,74.9a40,40,0,0,1,10.5-22.2l.3-.3,7.1,6.8a1.35,1.35,0,0,0,1.6.3,1.91,1.91,0,0,0,.7-1.4l.1-13.9a1.28,1.28,0,0,0-.4-1,1.43,1.43,0,0,0-1-.4l-13.8.6a1.51,1.51,0,0,0-1.3.8,2.06,2.06,0,0,0,.3,1.5l4.8,4.6-.3.3a44.08,44.08,0,0,0,26.6,73.5ZM20.53,46v9.1l-9.1-8.7Z",
    transform: "translate(0 -2.07)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,192.5h-7.5V171.8a.79.79,0,0,1,.8-.8h5.9a.79.79,0,0,1,.8.8Zm18.9,0h-7.5V154.7a.79.79,0,0,1,.8-.8h5.9a.79.79,0,0,1,.8.8Zm-41.4.5v1.8h46.5a1.22,1.22,0,0,0,1.2-1.2,1.16,1.16,0,0,0-1.2-1.2h-2.6V154.6a3.16,3.16,0,0,0-3.2-3.2H245a3.16,3.16,0,0,0-3.2,3.2v37.8h-6.6V171.7a3.16,3.16,0,0,0-3.2-3.2h-5.9a3.16,3.16,0,0,0-3.2,3.2v20.7h-6.6V181.6a3.16,3.16,0,0,0-3.2-3.2h-2.8v2.3h2.8a.79.79,0,0,1,.8.8v10.8h-4.32Z",
    transform: "translate(0 -2.07)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,135.3a1,1,0,0,0-.4-.9,1.49,1.49,0,0,0-.9-.4h-7.2a1.2,1.2,0,1,0,0,2.4H250L238.23,148l-4.5-4.4a1.23,1.23,0,0,0-.8-.4.81.81,0,0,0-.8.4l-21.4,21.3a1,1,0,0,0,0,1.6,1.52,1.52,0,0,0,.8.4.81.81,0,0,0,.8-.4l20.6-20.5,4.5,4.4a1,1,0,0,0,1.6,0l12.7-12.6v4a1.22,1.22,0,0,0,1.2,1.2,1.29,1.29,0,0,0,1.2-1.2Z",
    transform: "translate(0 -2.07)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,173.2h-4.1v19.9h4.1Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.23,183.1H212v10h-1.8",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,155.58h-4.1v37.86h4.1Z",
    transform: "translate(0 -2.07)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.6e81d0f4.svg";
export { ForwardRef as ReactComponent };